import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'

import { SharedModule } from 'src/app/shared/shared.module'
import { StoreModule } from '@ngrx/store'
import * as fromGiftCard from '../gift-card/gift-card.reducer'
import { EffectsModule } from '@ngrx/effects'
import { GiftCardEffects } from './gift-card.effects'
import { GiftCardService } from './gift-card.service'
import { GiftCardSerializer } from './gift-card.serializer'

@NgModule({
    imports: [
        SharedModule,
        StoreModule.forFeature(fromGiftCard.FEATURE_NAME, fromGiftCard.giftCardReducer),
        EffectsModule.forFeature([GiftCardEffects]),
        CommonModule
    ],
    declarations: [],
    providers: [
        GiftCardService,
        {
            provide: GiftCardSerializer,
            useClass: GiftCardSerializer
        }
    ]
})
export class GiftCardModule {}
